import { expertTitle } from '../../lib/teamApi'
import { sizedImageUrl } from '../../lib/remoteImage'
import './team-cards.css'

// One card per expert: portrait and job title, no name (see expertTitle).
// Shared by the homepage, /team and /about.
export default function ExpertRoster({ experts }) {
  if (!experts?.length) return null
  return (
    <ul className="tc-experts">
      {experts.map((member) => {
        const title = expertTitle(member)
        return (
          <li key={member.id || member.image_url} className="tc-expert">
            <img src={sizedImageUrl(member.image_url, 320)} alt={`${title} at GHL Prime`} loading="lazy" decoding="async" />
            <p className="tc-expert-title">{title}</p>
          </li>
        )
      })}
    </ul>
  )
}
